import React, { useState } from "react";
import useAuthenticationHook from "../../hook/useAuthenticationHook";
import { Typography } from "@mui/material";
import { signInWithGoogle, signInWithApple } from "../../services/authServices/auth.services";
import { useSnackbar } from "../../contexts/Snackbar.context";
import HindusRUsIcon from "../../assets/images/HindusRUsIcon.png";
import GoogleIcon from "../../assets/images/GoogleIcon.png";
import AppleIcon from "../../assets/images/AppleIcon.png";
import "./Login.style.css";

const Login = () => {
  const { showSnackbar } = useSnackbar();
  const { isLoadingAuth } = useAuthenticationHook();

  const [googleLoading, setGoogleLoading] = useState(false);
  const [appleLoading, setAppleLoading] = useState(false);

  const handleGoogleLogin = async () => {
    if (googleLoading || appleLoading || isLoadingAuth) return;
    setGoogleLoading(true);
    const { error } = await signInWithGoogle();
    setGoogleLoading(false);
    if (error) {
      // Use user-friendly error message if available, otherwise fallback to original message
      const errorMessage = error.userFriendlyMessage || "Google login failed";
      showSnackbar(errorMessage, "error");
      return;
    }
    // Optionally: redirect or trigger context update here
    // This will be handled by useAuthenticationHook
  };

  const handleAppleLogin = async () => {
    if (googleLoading || appleLoading || isLoadingAuth) return;
    setAppleLoading(true);
    const { error } = await signInWithApple();
    setAppleLoading(false);
    if (error) {
      // Use user-friendly error message if available, otherwise fallback to original message
      const errorMessage = error.userFriendlyMessage || "Apple login failed";
      showSnackbar(errorMessage, "error");
      return;
    }
    // Optionally: redirect or trigger context update here
    // This will be handled by useAuthenticationHook
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <img src={HindusRUsIcon} alt="Hindus R Us" className="login-logo" />

        <Typography variant="h5" className="login-title" align="center">
          Welcome to Hindus R Us
        </Typography>
        <Typography variant="body1" className="login-subtitle" align="center">
          Faith. Knowledge. Growth.
        </Typography>

        <div className="login-actions">
          {/* Google Login Button */}
          <div
            className="login-social-btn gap-2"
            onClick={handleGoogleLogin}
            style={{
              cursor:
                googleLoading || isLoadingAuth
                  ? "not-allowed"
                  : "pointer",
              opacity: googleLoading || isLoadingAuth ? 0.6 : 1,
            }}
          >
            <img src={GoogleIcon} alt="Google-Login" />
            <span className="login-type">
              {googleLoading
                ? "Signing in..."
                : "Continue with Google"}
            </span>
          </div>

          {/* Apple Login Button */}
          <div
            className="login-social-btn gap-2"
            onClick={handleAppleLogin}
            style={{
              cursor: appleLoading || isLoadingAuth
                  ? "not-allowed"
                  : "pointer",
              opacity: appleLoading || isLoadingAuth ? 0.6 : 1,
            }}
          >
            <img src={AppleIcon} alt="Apple-Login" />
            <span className="login-type">
              {appleLoading ? "Signing in..." : "Continue with Apple"}
            </span>
          </div>
        </div>

        <div className="login-terms">
          <Typography variant="body2" align="center" className="terms-text">
            By continuing, you agree to our
          </Typography>
          <Typography variant="body2" align="center" className="terms-links">
            <a href="/privacy" rel="noreferrer">
              Privacy Policy
            </a>
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default Login;
